import { render, staticRenderFns } from "./SelecaoUnicaTpl.vue?vue&type=template&id=1d577690&"
import script from "./SelecaoUnicaTpl.vue?vue&type=script&lang=js&"
export * from "./SelecaoUnicaTpl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/taylor-minhasvendas-frontend-teste/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d577690')) {
      api.createRecord('1d577690', component.options)
    } else {
      api.reload('1d577690', component.options)
    }
    module.hot.accept("./SelecaoUnicaTpl.vue?vue&type=template&id=1d577690&", function () {
      api.rerender('1d577690', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/lista-vez/SelecaoUnicaTpl.vue"
export default component.exports